import { cn } from "@/lib/utils";

const TYPE_CONFIG = {
  feature: { label: "Feature", color: "bg-type-feature/15 text-type-feature" },
  bug: { label: "Bug", color: "bg-type-bug/15 text-type-bug" },
  refacto: { label: "Refacto", color: "bg-type-refacto/15 text-type-refacto" },
  chore: { label: "Chore", color: "bg-type-chore/15 text-type-chore" },
} as const;

export type TicketType = keyof typeof TYPE_CONFIG;

export function TypeBadge({
  type,
  className,
}: {
  type: TicketType;
  className?: string;
}) {
  const config = TYPE_CONFIG[type];
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-md px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wider",
        config.color,
        className,
      )}
    >
      {config.label}
    </span>
  );
}
